import { styled } from "@mui/material";

const TEXT_COLOR = "#424242";

export const WeatherDayStyled = styled("div")({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "8px 6px",
  margin: "2px",
  maxHeight: "80px",
  border: "1px solid #dcdee6",
  borderRadius: "0.25rem",
  backgroundColor: "#fafafa",
  "&.today": {
    backgroundColor: "#eefcff",
    borderColor: "#eefcff",
  },
  "&.future": {
    backgroundColor: "#ffffff",
  },
  "&.interactive": {
    cursor: "pointer",
  },
  "&.selected": {
    borderWidth: "2px",
    borderColor: "#3A74BE",
    backgroundColor: "#F5F8F8",
  },
  "& .title": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& .box": {
      display: "flex",
      justifyContent: "space-between",
      "& img": {
        width: "45px",
        height: "45px",
      },
      "& .temp-wrapper": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        "& .temp": {
          color: TEXT_COLOR,
          "&.max": {
            fontSize: "20px",
          },
          "&.min": {
            fontSize: "16px",
            fontWeight: 400,
          },
          "@media (max-width: 1399)": {
            "&.max": {
              fontSize: "17px",
            },
            "&.min": {
              fontSize: "13px",
            },
          },
          "@media (max-width: 1299px)": {
            "&.max": {
              fontSize: "12px",
            },
            "&.min": {
              fontSize: "10px",
            },
          },
          "@media (max-width: 1199px)": {
            "&.max": {
              fontSize: "18px",
            },
            "&.min": {
              fontSize: "14px",
            },
          },
          "@media (max-width: 799px)": {
            "&.max": {
              fontSize: "16px",
            },
            "&.min": {
              fontSize: "12px",
            },
          },
        },
      },
    },
  },
});
